type SupportedChainTuple = typeof SUPPORTED_CHAINS;
export const SUPPORTED_CHAINS = ['ethereum', 'aptos', 'polygon'] as const;
export type SupportedChain = SupportedChainTuple[number];
export type SupportedNetworkName = Capitalize<SupportedChain>; // used in emoji.id BE requests
